export const PRODUCTBLOCK_LOADING = "PRODUCTBLOCK_LOADING";
export const PRODUCTBLOCK_RESET = "PRODUCTBLOCK_RESET";
export const GET_PRODUCTBLOCK = "GET_PRODUCTBLOCK";
export const GET_PRODUCTBLOCK_SUCCESS = "GET_PRODUCTBLOCK_SUCCESS";
export const GET_PRODUCTBLOCK_FAIL = "GET_PRODUCTBLOCK_FAIL";
export const DELETE_PRODUCTBLOCK = "DELETE_PRODUCTBLOCK"
export const DELETE_PRODUCTBLOCK_SUCCESS = "DELETE_PRODUCTBLOCK_SUCCESS"
export const DELETE_PRODUCTBLOCK_FAIL = "DELETE_PRODUCTBLOCK_FAIL"
export const UPDATE_PRODUCTBLOCK = "UPDATE_PRODUCTBLOCK"
export const UPDATE_PRODUCTBLOCK_SUCCESS = "UPDATE_PRODUCTBLOCK_SUCCESS"
export const UPDATE_PRODUCTBLOCK_FAIL = "UPDATE_PRODUCTBLOCK_FAIL"
export const ADD_NEW_PRODUCTBLOCK = "ADD_NEW_PRODUCTBLOCK"
export const ADD_PRODUCTBLOCK_SUCCESS = "ADD_PRODUCTBLOCK_SUCCESS"
export const ADD_PRODUCTBLOCK_FAIL = "ADD_PRODUCTBLOCK_FAIL"
export const PRODUCTBLOCK_RESET_CREATE = "PRODUCTBLOCK_RESET_CREATE"